import moment from 'moment';
import React, { useMemo, useState } from 'react';
import { Button, Drawer, List, Tag, Popconfirm, Skeleton } from 'antd';
import { StyledItem } from './styled';
import { TOOLTIP_LABEL_FORMAT } from '@src/utils/constants';
import { DeleteOutlined } from '@ant-design/icons';
import { useDeletePrompt } from './hooks/useDeletePrompt';
import useGetPrompts from './hooks/useGetPrompts';
import VersionsDrawer from './VersionsDrawer';
import EditDrawer from './EditDrawer';

export const ListItem = ({ item, setShowVersionDrawer, setSelectedRecordId }) => {
  const deleteMutation = useDeletePrompt({});

  const handleRecordClick = () => {
    setSelectedRecordId(item.id);
    setShowVersionDrawer(true);
  };

  const handleDelete = () => {
    deleteMutation.mutateAsync({ id: item.id });
  };

  return (
    <List.Item
      key={item.id}
      extra={
        <div style={{ display: 'flex', gap: 8, flexDirection: 'column' }}>
          <div>
            <span style={{ color: 'rgb(144, 144, 144)' }}></span>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <Popconfirm
              title="Delete system prompt"
              description="Are you sure to delete this prompt?"
              onConfirm={handleDelete}
              okText="Yes"
              cancelText="No"
            >
              <Button
                size="small"
                danger
                icon={<DeleteOutlined />}
                disabled={item.is_active}
                title="Delete"
              />
            </Popconfirm>
          </div>
        </div>
      }
    >
      <List.Item.Meta
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <StyledItem onClick={handleRecordClick}>{item.title}</StyledItem>
          </div>
        }
        description={
          <div style={{ display: 'flex', gap: 8 }}>
            <span>
              {moment(item.updatedAt).format(TOOLTIP_LABEL_FORMAT)}
              <br />
              {item.created_by_username || item.created_by}
            </span>
            {item.is_active && <Tag style={{ height: 20 }} color="green">active</Tag>}
          </div>
        }
      />
    </List.Item>
  );
};

const SystemPrompt = ({ open, setOpen }) => {
  const [selectedRecordId, setSelectedRecordId] = useState(null);
  const [showVersionDrawer, setShowVersionDrawer] = useState(false);
  const [showCreateDrawer, setShowCreateDrawer] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleCreate = () => {
    setSelectedRecordId(null);
    setShowCreateDrawer(true);
  };

  const { data = [], isFetching, isError } = useGetPrompts({ open });

  const selectedPrompt = useMemo(() => {
    return selectedRecordId ? data.find((item) => item.id === selectedRecordId) : null;
  }, [data, selectedRecordId]);

  return (
    <Drawer
      title="System Prompts"
      placement="left"
      closable={true}
      onClose={handleClose}
      open={open}
      width={500}
      extra={
        <Button type="primary" onClick={handleCreate}>
          Create
        </Button>
      }
      destroyOnHidden={true}
    >
      {isFetching ? (
        <Skeleton active />
      ) : (
        <List
          size="small"
          dataSource={data}
          renderItem={(item) => (
            <ListItem
              item={item}
              setShowVersionDrawer={setShowVersionDrawer}
              setSelectedRecordId={setSelectedRecordId}
            />
          )}
        />
      )}
      <VersionsDrawer
        selectedPrompt={selectedPrompt}
        showVersionDrawer={showVersionDrawer}
        setShowVersionsDrawer={setShowVersionDrawer}
      />
      <EditDrawer
        key={selectedRecordId}
        showEditDrawer={showCreateDrawer}
        selectedPrompt={null}
        editableVersion={null}
        setShowEditDrawer={setShowCreateDrawer}
      />
    </Drawer>
  );
};

export default SystemPrompt;
